<div class="press-page">
  <section class="hero-section">
    <div class="container">
      <div class="hero-content">
        <div class="logo-container">
          <img src="assets/images/logo-text-black.png" alt="Nuuduu Logo" i18n-alt class="company-logo">
        </div>
        <h1 class="hero-title" i18n>Transforming Work Through AI</h1>
        <p class="tagline" i18n>The Future of Work Platform</p>
        <div class="hero-description">
          <p i18n>
            Nuuduu is an AI-powered work platform that connects customers directly with verified service providers — with 0% commission, full partner control, and instant onboarding.
          </p>
          <p class="highlight-text" i18n>
            Live in 5 countries. Built for the EU market. Replacing the old model of gig apps and staffing agencies.
          </p>
        </div>
        <div class="press-kit-container">
          <a href="assets/press/nuuduu-press-kit.zip" download class="press-kit-button">
            <i class="fas fa-download"></i>
            <span i18n>Download Press Kit</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="video-showcase">
    <div class="container">
      <h2 class="section-title" i18n>Featured Videos</h2>
      <div class="videos-grid">
        <div class="video-container">
          <iframe
            src="https://www.youtube.com/embed/TqAxhfuCRGA"
            title="Nuuduu Showcase"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
        <div class="video-container">
          <iframe
            src="https://www.youtube.com/embed/GnKKygFQShA"
            title="Nuuduu Features"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
      </div>
    </div>
  </section>

  <section class="featured-press-release">
    <div class="container">
      <div class="press-release-content">
        <div class="label" i18n>Featured Press Release</div>
        <h2 class="release-title" i18n>Nuuduu rolls out in 5 countries with 0% commission model</h2>
        <div class="release-meta">
          <span class="date" i18n>June 30th, 2025</span>
          <span class="location" i18n>Kaunas, Lithuania</span>
        </div>
        <div class="release-teaser">
          <p i18n>
            Nuuduu, the innovative AI-powered work platform, announces its successful expansion into five European countries, 
            revolutionizing the gig economy with its groundbreaking 0% commission model. This expansion marks a significant 
            milestone in transforming how service providers and customers connect, offering unprecedented financial benefits 
            and operational freedom to partners across the EU market.
          </p>
        </div>
        <div class="release-actions">
          <a [href]="'assets/press/releases/2025-06-30-nuuduu-'+locale+'.pdf'" target="_system" class="read-more-button" target="_blank">
            <span i18n>Read Full Release</span>
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="media-kit">
    <div class="container">
      <h2 class="section-title" i18n>Media Kit Assets</h2>
      
      <div class="asset-group">
        <h3 i18n>Logos</h3>
        <div class="assets-grid">
          <div class="asset-card">
            <div class="asset-preview white-bg">
              <img src="assets/press/logos/nuuduu-text-light.png" alt="Nuuduu Text Logo Light" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Light Background Text Logo</span>
              <div class="download-options">
                <a href="assets/press/logos/nuuduu-text-light.pdf" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/logos/nuuduu-text-light.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview light-bg">
              <img src="assets/press/logos/nuuduu-text-transparent.png" alt="Nuuduu Text Logo Transparent" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Transparent Background Text Logo</span>
              <div class="download-options">
                <a href="assets/press/logos/nuuduu-text-transparent.pdf" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/logos/nuuduu-text-ligtransparentht.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview black-bg">
              <img src="assets/press/logos/nuuduu-text-dark.png" alt="Nuuduu Text Logo Dark" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Dark Background Text Logo</span>
              <div class="download-options">
                <a href="assets/press/logos/nuuduu-text-dark.pdg" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/logos/nuuduu-text-dark.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview white-bg">
              <img src="assets/press/logos/nuuduu-logo-blue.png" alt="Nuuduu Logo Blue" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Blue Round Logo</span>
              <div class="download-options">
                <a href="assets/press/logos/nuuduu-logo-blue.pdg" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/logos/nuuduu-logo-blue.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview white-bg">
              <img src="assets/press/logos/nuuduu-logo-black.png" alt="Nuuduu Logo Black" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Black Background Logo</span>
              <div class="download-options">
                <a href="assets/images/logos/nuuduu-logo-black.pdg" download class="download-btn" i18n>PDF</a>
                <a href="assets/images/logos/nuuduu-logo-black.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="asset-group">
        <h3 i18n>Screenshots</h3>
        <div class="assets-grid-small">
          <div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-ar.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Arabic)</span>
              <a href="assets/press/screenshots/nuuduu-ar" download class="download-btn" i18n>PNG</a>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-et.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Estonian)</span>
              <a href="assets/press/screenshots/nuuduu-et" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-en.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (English)</span>
              <a href="assets/press/screenshots/nuuduu-en" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-fi.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Finnish)</span>
              <a href="assets/press/screenshots/nuuduu-fi" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-lt.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Lithuanian)</span>
              <a href="assets/press/screenshots/nuuduu-lt" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-lv.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Latvian)</span>
              <a href="assets/press/screenshots/nuuduu-lv" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-ru.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Russian)</span>
              <a href="assets/press/screenshots/nuuduu-ru" download class="download-btn" i18n>PNG</a>
            </div>
          </div><div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/screenshots/nuuduu-sv.png" alt="Nuuduu App Screenshots" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App</span>
              <span class="asset-description" i18n>Sales Assistant (Swedish)</span>
              <a href="assets/press/screenshots/nuuduu-sv" download class="download-btn" i18n>PNG</a>
            </div>
          </div>
        </div>
      </div>

      <div class="asset-group">
        <h3 i18n>App Icons</h3>
        <div class="assets-grid">
          <div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/icons/nuuduu.png" alt="Nuuduu App Icon" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu App Icon</span>
              <div class="download-options">
                <a href="assets/press/icons/nuuduu.pdf" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/icons/nuuduu.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
          <div class="asset-card">
            <div class="asset-preview">
              <img src="assets/press/icons/nuuduu-partner.png" alt="Nuuduu Partner App Icon" i18n-alt>
            </div>
            <div class="asset-info">
              <span class="asset-name" i18n>Nuuduu Partner App Icon</span>
              <div class="download-options">
                <a href="assets/press/icons/nuuduu-partner.pdf" download class="download-btn" i18n>PDF</a>
                <a href="assets/press/icons/nuuduu-partner.png" download class="download-btn" i18n>PNG</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="key-facts">
    <div class="container">
      <h2 class="section-title" i18n>Key Facts & Numbers</h2>
      <div class="facts-grid">
        <div class="fact-item">
          <span class="fact-icon">🌍</span>
          <h3 i18n>Live in</h3>
          <p i18n><ng-container *ngFor="let org of organizations | localeSort: 'country'; let i = index">{{ org | translateField: 'country' }}{{ i < organizations.length - 1 ? ', ' : '' }}</ng-container></p>
        </div>
        <div *ngIf="stats" class="fact-item">
          <span class="fact-icon">💼</span>
          <h3 i18n>Services</h3>
          <p i18n>{{ stats.assignments }} categories and {{ stats.products }} services supported</p>
        </div>
        <div *ngIf="platform_fee && organization" class="fact-item">
          <span class="fact-icon">💰</span>
          <h3 i18n>{{ platform_fee | translateField: 'title' }}</h3>
          <p i18n>{{ platform_fee.fee_amount | currency: organization.currency }} per work shift</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">📉</span>
          <h3 i18n>Customer savings</h3>
          <p i18n>Up to 40% vs. traditional vendors</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">🔁</span>
          <h3 i18n>Commission</h3>
          <p i18n>0%</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">🎯</span>
          <h3 i18n>Targets</h3>
          <p i18n>10,000 partners / 1M customers in 12 months</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">🤖</span>
          <h3 i18n>Tech</h3>
          <p i18n>AI-powered onboarding, salary rules, 24/7 support</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">✅</span>
          <h3 i18n>Verification</h3>
          <p i18n>Verified via national business registries</p>
        </div>
        <div class="fact-item">
          <span class="fact-icon">📱</span>
          <h3 i18n>Apps</h3>
          <p i18n>Available on iOS & Android</p>
        </div>
      </div>
    </div>
  </section>

  <section class="social-media">
    <div class="container">
      <h2 class="section-title" i18n>Social Media</h2>
      <div class="social-links">
        <a [href]="(organization | translateField: 'customer_facebook_link') || defaultFacebookLink" target="_blank" class="social-link">
          <fa-icon [icon]="fa.faFacebookSquare"></fa-icon>
          <span i18n>Facebook</span>
        </a>
        <a [href]="(organization | translateField: 'customer_x_link') || defaultXLink" target="_blank" class="social-link">
          <span class="x-logo">𝕏</span>
          <span i18n>X (Twitter)</span>
        </a>
        <a [href]="(organization | translateField: 'customer_youtube_link') || defaultYoutubeChannelLink" target="_blank" class="social-link">
          <fa-icon [icon]="fa.faYoutube" style="color: #ff0000;"></fa-icon>
          <span i18n>YouTube</span>
        </a>
      </div>
    </div>
  </section>

  <section class="press-contact">
    <div class="container">
      <h2 class="section-title" i18n>Press Contact</h2>
      <div class="contact-info">
        <div class="contact-item">
          <span class="contact-icon">📧</span>
          <a href="mailto:press@nuuduu.com" i18n>press&#64;nuuduu.com</a>
        </div>
        <div class="contact-item">
          <span class="contact-icon">📍</span>
          <span i18n>Kaunas, Lithuania</span>
        </div>
        <div class="contact-item">
          <span class="contact-icon">🌐</span>
          <a href="https://nuuduu.com" target="_blank" i18n>nuuduu.com</a>
        </div>
      </div>
    </div>
  </section>
</div>
<br>